import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Paper,
  CircularProgress,
  Alert,
} from '@mui/material';
import { Note, TaskAlt, Notifications, MoreHoriz } from '@mui/icons-material';
import { format } from 'date-fns';
import { pl } from 'date-fns/locale';

const ACTIVITY_ICONS = {
  NOTE: Note,
  TASK: TaskAlt,
  REMINDER: Notifications,
};

const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  try {
    return format(new Date(dateStr), 'dd MMM yyyy, HH:mm', { locale: pl });
  } catch {
    return dateStr;
  }
};

const TimelineItem = ({ entry, isLast }) => {
  const Icon = ACTIVITY_ICONS[entry.type] || MoreHoriz;
  const formattedDate = formatDate(entry.getDisplayDate());

  return (
    <Box sx={{ display: 'flex', position: 'relative', pb: isLast ? 0 : 3 }}>
      {!isLast && (
        <Box
          sx={{
            position: 'absolute',
            left: 15,
            top: 32,
            bottom: 0,
            width: 2,
            bgcolor: 'divider',
          }}
        />
      )}

      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          zIndex: 1,
        }}
      >
        <Icon sx={{ fontSize: 16 }} />
      </Box>

      <Box sx={{ ml: 2, flex: 1, minWidth: 0 }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
            {entry.createdBy || 'Nieznany'}
          </Typography>
          <Typography variant="caption" color="text.disabled">
            ·
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
            {formattedDate}
          </Typography>
          <Chip label={entry.getTypeLabel()} size="small" variant="outlined" />
        </Box>

        <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
          {entry.comment || '—'}
        </Typography>
      </Box>
    </Box>
  );
};

const ContactTimeline = ({ activities, isLoading, error }) => {
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 1 }}>
        Nie udało się załadować historii kontaktu.
      </Alert>
    );
  }

  if (!activities?.length) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
        Brak wpisów w historii kontaktu.
      </Typography>
    );
  }

  return (
    <Paper variant="outlined" sx={{ p: 2, bgcolor: 'background.default' }}>
      {activities.map((entry, index) => (
        <TimelineItem
          key={entry.id || index}
          entry={entry}
          isLast={index === activities.length - 1}
        />
      ))}
    </Paper>
  );
};

export default ContactTimeline;
